import _ from 'lodash';
import {
  determineErrorFromResponse,
  determineErrorIfStaticRender,
  isStaticRender,
  isEpisode,
} from 'helpers/ContentHelper';
import {
  CLEAR_WATCH,
  FETCH_MOVIE_DETAIL,
  FETCH_WATCH,
  FETCH_WATCH_ERROR,
  SET_NEXT_PAGE,
  SET_WATCH_PANELS,
} from './WatchActions';

const INITIAL_STATE = {
  panels: null,
  seo: null,
  errors: null,
  video: null,
  panelVideo: null,
  next: null,
  endcard: null,
  releaseUrl: null,
  restartPlayerScreenUrl: null,
  restartData: null,
  isStatic: false,
  playlistData: null,
  percentWatched: 0,
  pagination: {},
  vodContentSet: false,
};

export default function(state = INITIAL_STATE, action) {
  let errors = determineErrorFromResponse(action);
  switch (action.type) {
    case FETCH_WATCH: {
      const data = _.get(action, 'payload.data');
      const panels = _.get(data, 'panels');
      const seo = _.get(data, 'SEO');
      const videoData = _.get(panels, 'member.0.items.member.0') || _.get(state, 'video');
      const videoType = _.get(videoData, 'videoType');
      const isFullEpisode = isEpisode(videoType);
      const panelVideo = videoData && { ...videoData, isFullEpisode, videoFormat: 'vod' };
      const nextState = {
        ...state,
        panels,
        panelVideo,
        seo,
        errors,
        isStatic: isStaticRender(),
        video: null,
        vodContentSet: false,
      };

      return nextState;
    }
    case SET_WATCH_PANELS: {
      const data = _.get(action, 'payload.data');
      const panels = _.get(data, 'panels');
      const seo = _.get(data, 'SEO');
      const videoData = _.get(panels, 'member.0.items.member.0') || _.get(state, 'video');
      const videoType = _.get(videoData, 'videoType');
      const isFullEpisode = isEpisode(videoType);
      const panelVideo = videoData && { ...videoData, isFullEpisode, videoFormat: 'vod' };
      const playerScreenUrl = _.get(videoData, 'playerScreenUrl', false);
      const favoritableItems = _.get(videoData, 'favoritableItems');
      const isVodUnavailable = !playerScreenUrl;

      const nextState = {
        ...state,
        errors,
        favoritableItems,
        isStatic: isStaticRender(),
        isVodUnavailable,
        pagination: {},
        panelVideo,
        panels,
        seo,
        video: null,
        releaseUrl: null,
      };

      return nextState;
    }
    case SET_NEXT_PAGE: {
      const data = _.get(action, 'payload');
      const { results, panelId } = data;
      const pages = _.get(state, `pagination.${panelId}`, []);
      const nextPages = [...pages, results.data];
      const nextPagination = { ...state.pagination, [panelId]: nextPages };
      return { ...state, pagination: nextPagination };
    }
    case FETCH_MOVIE_DETAIL: {
      const seo = _.get(action, 'payload.data.SEO');
      const nextState = { ...state };
      if (seo) nextState.seo = seo;
      nextState.isStatic = isStaticRender();
      return nextState;
    }
    case CLEAR_WATCH: {
      return {
        ...state,
        ...INITIAL_STATE,
      };
    }
    case FETCH_WATCH_ERROR: {
      errors = errors || determineErrorIfStaticRender();
      return {
        ...state,
        errors,
      };
    }
    default:
      return state;
  }
}
